import { useState, useEffect } from 'react';

/**
 * Custom hook for responsive breakpoint detection
 * @param {string} query - CSS media query string
 * @returns {boolean} - Whether the media query matches
 */
export function useMediaQuery(query) {
    const getMatches = () => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };

    const [matches, setMatches] = useState(getMatches);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const mediaQuery = window.matchMedia(query);

        const handler = () => setMatches(mediaQuery.matches);

        handler();

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handler);
            return () => mediaQuery.removeEventListener('change', handler);
        } else {
            mediaQuery.addListener(handler);
            return () => mediaQuery.removeListener(handler);
        }
    }, [query]);

    return matches;
}

/**
 * Hook for detecting small screens (mobile/tablet)
 * @returns {boolean} - true if screen width <= 768px
 */
export function useIsSmallScreen(width = 768) {
    return useMediaQuery(`(max-width: ${width}px)`);
}

export default useMediaQuery;
